import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
    try {
        const token = localStorage.getItem("token") || null;
        const user = localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user"))
            : "";

        if (token && user) {
            return <Navigate to={"/dashboard"} replace />;
        }
        return children;
    } catch (error) {
        console.log(error, "error");
        return children;
    }
};

export default PublicRoute;
